module.exports = __webpack_public_path__ + "img/vehicle-slides-backdrop-lincoln.3e0c995f.png";